import { DateRange, getDomainPoints } from 'bold-ui/lib/components/Chart'
import { SexoEnum } from 'graphql/types.generated'
import moment, { Duration, Moment } from 'moment'
import { createParameters, TipoMedicao } from 'util/atendimento/percentis/calculatePercentil'

export type ReferenceAreasCalculator = {
  date: Moment
  referenceAreaCalculator: (percentil: number) => number
}

export function getLinearAreaInRange(xRange: DateRange, range: { max?: number }) {
  return [
    {
      x: xRange.init,
      upperLimit: range.max,
    },
    {
      x: xRange.end,
      upperLimit: range.max,
    },
  ]
}

export function getReferenceAreasCalculators(
  sexo: SexoEnum,
  dataNascimento: Moment,
  xRange: DateRange,
  medicao: TipoMedicao,
  shouldRenderPreTermo: boolean = false
): ReferenceAreasCalculator[] {
  const maxIdadeNoRange = moment.duration(moment(xRange.end).diff(dataNascimento))

  const refAreaDomain = shouldRenderPreTermo
    ? getRefAreaDomainPreTermo(xRange)
    : getRefAreaDomainPadrao(maxIdadeNoRange, xRange)

  return getDomainPoints<Moment>(refAreaDomain).map((date) => ({
    date: date,
    referenceAreaCalculator: getReferenceAreaCalculator(sexo, date, dataNascimento, medicao, shouldRenderPreTermo),
  }))
}

const getRefAreaDomainPreTermo = (dataRange: DateRange): DateRange => ({
  ...dataRange,
  step: { unit: 'week', amount: 1 },
})

function getRefAreaDomainPadrao(maxIdadeNoRange: Duration, dataRange: DateRange): DateRange {
  if (maxIdadeNoRange.years() <= 2) return { ...dataRange, step: { unit: 'day', amount: 1 } }
  else if (maxIdadeNoRange.years() <= 5) return { ...dataRange, step: { unit: 'day', amount: 10 } }
  else return { ...dataRange, step: { unit: 'month', amount: 1 } }
}

const MS_POR_DIA = 24 * 60 * 60 * 1000
const DIAS_POR_SEMANA = 7

function getReferenceAreaCalculator(
  sexo: SexoEnum,
  dataMedicao: Moment,
  dataNascimento: Moment,
  medicao: TipoMedicao,
  shouldRenderPreTermo: boolean
): (percentil: number) => number {
  const idade = shouldRenderPreTermo
    ? calcularIdadePreTermo(dataMedicao, dataNascimento)
    : moment.duration(moment(dataMedicao).diff(dataNascimento, 'days'), 'days')

  const params = createParameters(
    sexo === SexoEnum.MASCULINO ? SexoEnum.MASCULINO : SexoEnum.FEMININO,
    idade.asYears(),
    medicao,
    Math.round,
    shouldRenderPreTermo
  )

  return (x) => params.calcularPercentil(x)
}

function calcularIdadePreTermo(dataMedicao: Moment, dataNascimento: Moment): moment.Duration {
  const diffMs = dataMedicao.valueOf() - dataNascimento.valueOf()
  const idadeEmDias = Math.round(diffMs / MS_POR_DIA)
  const idadeEmDiasArredondada = Math.round(idadeEmDias / DIAS_POR_SEMANA) * DIAS_POR_SEMANA

  return moment.duration(idadeEmDiasArredondada, 'days')
}
